import { useEffect, useState } from 'react'
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout'
import { useDispatch } from 'react-redux';
import { Box, Button, Card, Tab, Tabs } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import AddEditNotification from './AddEditNotification';
import NotificationList from './NotificationList';

const NotificationModule = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'notifications'
        });
    }, []);
    const [tabValue, setTabValue] = useState('1');
        
    // Handle tab change and update URL
        const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
  return (
    <>
        <PageHeaderLayout headerTitle={'Cudel Notification'}>
            <Button sx={{textTransform:'none'}} size='small' variant='contained' startIcon={<ArrowBack/>}>
                Back
            </Button>
        </PageHeaderLayout>
        {/* <AbandonedCartList/> */}
        {/* <AddEditNotification/> */}
        {/* <NotificationDashboard/> */}
        <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                    sx={{ p: 0, minHeight: '40px' }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
    
                <Tab value="0" label="Create Notification" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
                <Tab value="1" label="Notication List" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                {/* <Tab value="three" label="Item Three" /> */}
                </Tabs>
            </Box>
        </Card>
        {tabValue === '0' && <AddEditNotification setTabValue={setTabValue} />}
        {tabValue === '1' && <NotificationList />}
    </>
  )
}

export default NotificationModule